import {request, serviceUrl} from "@/utils/request";

// 获取告警屏蔽策略  pageSize pageCurrent
export function list(pageSize = null, pageCurrent = null,
                     gatewaySn = null, spaceId = null,
                     deviceId = null, pointId = null) {
  return request({
    url: serviceUrl.deviceService + '/alarm/shield/list',
    params: {
      pageSize,
      pageCurrent,
      gatewaySn, spaceId, deviceId, pointId
    }
  })
}

// 批量保存告警屏蔽策略
export function updateBatch(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/shield/updateBatch',
    data: params
  })
}

// 批量保存告警屏蔽策略
export function saveBatch(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/shield/saveBatch',
    data: params
  })
}

// 删除告警屏蔽策略
export function deleteById(id) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/alarm/shield/deleteById',
    params: id
  })
}

// 根据id获取告警屏蔽策略
export function getById(id) {
  return request({
    url: serviceUrl.deviceService + '/alarm/shield/getById',
    params: id
  })
}

// 启用/停用告警屏蔽策略
export function shieldSwitch(id, isEnable) {
  return request({
    url: serviceUrl.deviceService + '/alarm/shield/shieldSwitch',
    params: {id, isEnable}
  })
}
